import { connect } from 'react-redux';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import type { SecondaryPriceType } from 'state/secondaryMarket/productSearch';
import { secondaryMarketQuoteCancelledThunk } from 'state/secondaryMarket/realtimeQuote/quote/quote.thunks';
import { getSecondaryMarketRealtimeAstroProductFromTab } from 'state/secondaryMarket/referential/astroProduct/astroProduct.selectors';
import type { TradeWay } from 'state/secondaryMarket/secondaryMarket.model';
import { fromSecondaryMarket } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

type OwnProps = Readonly<{
  tabId: string;
}>;

type StateProps = Readonly<{
  price: number;
  priceType: SecondaryPriceType;
  priceCurrency: string;
  tradeWay: TradeWay;
}>;

type DispatchProps = Readonly<{
  onClick: () => void;
}>;

export type TradedSidePanelProps = OwnProps & StateProps & DispatchProps;

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  const quoteId = fromSecondaryMarket.realtimeQuote.form.getSecondaryMarketRtFormQuoteId(state, tabId)!;
  const price = fromSecondaryMarket.realtimeQuote.quote.getSecondaryQuoteSettlementPrice(state, quoteId)!;
  const priceType = fromSecondaryMarket.realtimeQuote.quote.getSecondaryQuotePriceType(state, quoteId)!;
  const product = getSecondaryMarketRealtimeAstroProductFromTab(state, tabId);
  const priceCurrency = product?.data?.currency!;
  const tradeWay = fromSecondaryMarket.realtimeQuote.form.getSecondaryMarketRtFormTradeWay(state, tabId)!;

  return {
    price,
    priceType,
    priceCurrency,
    tradeWay,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch, { tabId }: OwnProps) => {
  return {
    onClick: () => {
      dispatch(secondaryMarketQuoteCancelledThunk(tabId));
      logAnalytics.trackEvent('Secondary market', 'Cancel quote');
    },
  };
};

export const connectTradedSidePanel = connect(mapStateToProps, mapDispatchToProps);
